/* eslint-disable import/no-webpack-loader-syntax */
/* eslint-disable global-require */
/**
 * app.js
 *
 * This is the entry file for the application, only setup and boilerplate
 * code.
 */

// Needed for redux-saga es6 generator support
import 'babel-polyfill';

// Import all the third party stuff
import React from 'react';
import ReactDOM from 'react-dom';
// import logger from './logger';
import { ApolloProvider } from 'react-apollo';
import { Detector } from 'react-detect-offline';
import { toast } from 'react-toastify';
import { Icon } from 'semantic-ui-react';
import MessengerCustomerChat from 'react-messenger-customer-chat';
import { FB_APP_ID, FB_PAGE_ID } from 'config/constants';

import './config/rollbar';
// import './config/reactotronConfig'
// import 'sanitize.css/sanitize.css';

// Import root app
import LocalizedRouter from 'components/LocalizedRouter';
import App from 'containers/App';

import { initGoogleAuth, initFacebookAuth } from 'lib/socialAuthHandler';
initGoogleAuth();
initFacebookAuth();

// Load the favicon, the manifest.json file and the .htaccess file
/* eslint-disable import/no-unresolved, import/extensions */
import '!file-loader?name=[name].[ext]!./images/favicon.ico';
import '!file-loader?name=[name].[ext]!./manifest.json';
import 'file-loader?name=[name].[ext]!./.htaccess';
/* eslint-enable import/no-unresolved, import/extensions */

import apolloClient from './apolloClient';

// Import i18n messages
import { translationMessages } from './i18n';

// Import CSS reset and Global Styles
import './global-styles';
import './lib/helpers';

const MOUNT_NODE = document.getElementById('app');

const render = (messages) => {
  // logger.load()
  ReactDOM.render(
    <ApolloProvider client={apolloClient}>
      {/* <BrowserRouter> */}
      <LocalizedRouter messages={messages}>
        <div>
          <Detector
            render={({ online }) => {
              let offlineToast;
              if (!online && !toast.isActive(offlineToast)) {
                offlineToast = toast.warn(
                  <div>
                    <Icon
                      style={{ color: 'red' }}
                      size="big"
                      name="warning sign"
                    />
                    {" You're offline. Check your connection."}
                  </div>,
                  {
                    autoClose: false,
                    closeButton: false,
                    closeOnClick: false,
                    className: 'offlineToast',
                    onClose: () => {
                      offlineToast = null;
                    },
                  }
                );
              } else {
                toast.dismiss(offlineToast);
                offlineToast = null;
              }
              return null;
            }}
          />

          <App />

          {process.env.NODE_ENV === 'production' && (
            <MessengerCustomerChat pageId={FB_PAGE_ID} appId={FB_APP_ID} />
          )}
        </div>
      </LocalizedRouter>
      {/* </BrowserRouter> */}
    </ApolloProvider>,
    MOUNT_NODE
  );
};

if (module.hot) {
  // Hot reloadable React components and translation json files
  // modules.hot.accept does not accept dynamic dependencies,
  // have to be constants at compile-time
  module.hot.accept(['./i18n', 'containers/App'], () => {
    ReactDOM.unmountComponentAtNode(MOUNT_NODE);
    render(translationMessages);
  });
}

// Chunked polyfill for browsers without Intl support
if (!window.Intl) {
  new Promise((resolve) => {
    resolve(import('intl'));
  })
    .then(() => Promise.all([import('intl/locale-data/jsonp/en.js')]))
    .then(() => render(translationMessages))
    .catch((err) => {
      throw err;
    });
} else {
  render(translationMessages);
}

// Install ServiceWorker and AppCache in the end since
// it's not most important operation and if main code fails,
// we do not want it installed
// if (process.env.NODE_ENV === 'production') {
//   const runtime = require('offline-plugin/runtime');

//   runtime.install({
//     onUpdating: () => {
//       // console.log('SW Event:', 'onUpdating');
//     },
//     onUpdateReady: () => {
//       // console.log('SW Event:', 'onUpdateReady');
//       // Tells to new SW to take control immediately
//       runtime.applyUpdate();
//     },
//     onUpdated: () => {
//       // console.log('SW Event:', 'onUpdated');
//       // Reload the webpage to load into the new version
//       window.location.reload();
//     },

//     onUpdateFailed: () => {
//       // console.log('SW Event:', 'onUpdateFailed');
//     },
//   }); // eslint-disable-line global-require

//   // remove console.log from production
//   // console.log = function() {}
// }



// WEBPACK FOOTER //
// ./app/app.js